<script setup lang="ts">
const { currentSearch } = useNavigation()
const { navPathViewTestId } = useTestId()
const { navSearchId } = useGlobals()
</script>

<template>
  <nav-pill
    v-if="currentSearch"
    :id="navSearchId"
    class="search-pill-container"
    :data-testid="navPathViewTestId"
  >
    <nav-pill-button
      :data-path-search-id="currentSearch.id"
      class="search-pill-button"
    >
      <search-path :search="currentSearch.asStatic()" class="search-path" />
    </nav-pill-button>
  </nav-pill>
  <div v-else>
    ???
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.search-pill-container
  @apply overflow-hidden

.search-pill-button
  @apply flex-none pr-1.5 text-[#{$pill-path-t-focused}]

.search-path
  @apply max-w-120 h-full gap-[#{$pill-gap-default}]
</style>
